import { useRef } from 'react';

const usePrevious = (value, isEqualFunc) => {
    const ref = useRef({
        value: value,
        prev: null,
    });

    const current = ref.current.value;
    if (isEqualFunc ? !isEqualFunc(current, value) : value !== current) {
        ref.current = {
            value: value,
            prev: current
        };
    }

    return ref.current.prev;
};

export default usePrevious;
